// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2691":"727973242bb33abd","2888":"ac68a23bc80de216","6713":"727973242bb33abd"}[chunkId] + ".css";
};